import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastViewport,
} from '@/components/ui/toast/toast.component';
import { useToast } from '@/hooks/use-toast.hook';

export const ToastContainer = () => {
  const { toasts } = useToast();
  return (
    <ToastProvider>
      {toasts.map(({ id, description, variant, ...props }) => {
        return (
          <Toast data-testid="toast-container" key={id} {...props} variant={variant}>
            {description && (
              <ToastDescription data-testid="toast-description" variant={variant}>
                {description}
              </ToastDescription>
            )}
            <ToastClose data-testid="toast-close" />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
};
